import { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Button, Typography } from "@mui/material";
import {
  ACTIVE_AREA_MASTER,
  DELETE_SLOT_COUNT,
  GET_ALL_SLOT_COUNT,
  GET_PARKING_TYPE1,
  RESTORE_SLOT_COUNT,
  SAVE_EDIT_SLOT_COUNT,
  VEHICLE_TYPE,
} from "../../../services/apiUrls";
import { Delete, get, post, Put } from "../../../services/service";
import axios from "axios";
import useIsEqual from "./useIsEqual";
import toast from "react-hot-toast";

const INITIAL_FORM_STATE = {
  id: "",
  vehicleType: "",
  parkingType: "",
  currentCount: "",
  totalCount: "",
  locationId: localStorage.getItem("locationId"),
  tenantId: localStorage.getItem("tenantId"),
};

export function useSlotCount() {
  let locationId = localStorage.getItem("locationId");
  let tenantId = localStorage.getItem("tenantId");

  const [open, setOpen] = useState(false);

  const [search, setSearch] = useState("");

  const [loading, setLoading] = useState(true);

  const [slotCounts, setSlotCounts] = useState([]);

  const [parkingOptions, setParkingOptions] = useState([]);

  const [vehicleTypeOptions, setVehicleTypeOptions] = useState([]);

  const [errorMessage, setErrorMessage] = useState("");

  const [formValues, setFormValues] = useState(INITIAL_FORM_STATE);

  const { isEqual, isSpace } = useIsEqual();

  const columns = [
    {
      field: "No.",
      headerName: "NO.",
      width: 65,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "totalCount",
      headerName: "TOTAL SLOT COUNT",
      flex: 1,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "currentCount",
      headerName: "CURRENT SLOT COUNT",
      flex: 1,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "vehicleName",
      headerName: "VEHICLE TYPE",
      flex: 1,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "parkingName",
      headerName: "PARKING TYPE",
      flex: 1,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "deleted",
      headerName: "STATUS",
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Box>
            <Button
              onClick={() => {
                statusInactive(params.row);
              }}
            >
              {params?.row?.deleted === false ? (
                <Button
                  variant="contained"
                  size="small"
                  color="success"
                  sx={{ width: "2rem" }}
                >
                  <Typography sx={{ fontSize: "10px" }}>Active</Typography>
                </Button>
              ) : (
                <Button
                  variant="contained"
                  size="small"
                  color="error"
                  sx={{ width: "2rem" }}
                >
                  <Typography sx={{ fontSize: "10px" }}>Inactive</Typography>
                </Button>
              )}
            </Button>
          </Box>
        );
      },
    },
    {
      field: "action",
      headerName: "ACTION",
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <EditIcon
            sx={{ cursor: "pointer" }}
            onClick={() => {
              setOpen(true);
              window.scrollTo(0, 0);
              console.log(params.row);
              setFormValues({
                id: params.row.id,
                vehicleType: params.row.vehicleType,
                parkingType: params.row.parkingType,
                currentCount: params.row.currentCount,
                totalCount: params.row.totalCount,
                locationId: INITIAL_FORM_STATE.locationId,
                tenantId: INITIAL_FORM_STATE.tenantId,
              });
            }}
          />
        );
      },
    },
  ];

  const handleInputChange = (e) => {
    setErrorMessage("");
    let convertedValue = isSpace(e.target.value);
    setFormValues({ ...formValues, [e.target.name]: convertedValue });
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const getVehicleParkingOptions = async () => {
    try {
      const vehichleTypeResponse = await get(
        `${VEHICLE_TYPE.replace("{locationId}", locationId).replace(
          "{tenantId}",
          tenantId
        )}`
      );
      const parkingOptions = await get(
        `${GET_PARKING_TYPE1.replace("{locationId}", locationId).replace(
          "{tenantId}",
          tenantId
        )}`
      );
      if (vehichleTypeResponse) setVehicleTypeOptions(vehichleTypeResponse);
      if (parkingOptions) setParkingOptions(parkingOptions);
    } catch (err) {
      console.log(err);
    }
  };

  const rows = search
    ? slotCounts.filter(
        (item) =>
          item?.vehicleName?.toLowerCase().includes(search.toLowerCase()) ||
          item?.parkingName?.toLowerCase().includes(search.toLowerCase())
      )
    : slotCounts;

  const isDisabled =
    formValues.vehicleType !== "" &&
    formValues.parkingType !== "" &&
    formValues.currentCount !== "" &&
    formValues.totalCount !== "";

  const handleClose = () => {
    setOpen(false);
    handleClear();
  };

  const handleOpenForm = () => {
    setOpen(true);
    handleClear();
    setErrorMessage("");
  };

  const handleClear = () => {
    setFormValues(INITIAL_FORM_STATE);
  };

  const getSlotCounts = async () => {
    setLoading(true);
    const url = `${GET_ALL_SLOT_COUNT.replace(
      "{locationId}",
      locationId
    ).replace("{tenantId}", tenantId)}`;

    try {
      const resp = await get(url);
      if (resp) {
        const datas = resp.map((item) => {
          return {
            ...item,
            vehicleType: item.vehicle.id,
            vehicleName: item.vehicle.name,
            parkingType: item.parking.id,
            parkingName: item.parking.name,
          };
        });
        setSlotCounts(datas);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    try {
      let url = SAVE_EDIT_SLOT_COUNT;
      let resp;
      const data = {
        ...formValues,
        vehicle: { id: formValues.vehicleType },
        parking: { id: formValues.parkingType },
      };

      delete data.vehicleType;
      delete data.parkingType;

      if (!formValues.id) {
        resp = await post(url, data);
      } else {
        resp = await Put(url, data);
      }
      if (resp && resp?.id) {
        handleClear();
        handleClose();
        getSlotCounts();
        toast.success(
          `Slot Count ${formValues.id ? "updated" : "saved"} successfully`
        );
      } else if (resp?.id == null) {
        toast.error("Slot Count already exists");
      }
    } catch (err) {
      if (err.response && err?.response.data)
        setErrorMessage(err.response.data.message);
      console.log(err);
    }
  };

  // GATE MASTER STATUS INACTIVE
  const statusInactive = async (data) => {
    let url = DELETE_SLOT_COUNT;
    if (data.deleted) url = RESTORE_SLOT_COUNT;
    try {
      const resp = await Delete(
        `${url
          .replace("{locationId}", locationId)
          .replace("{tenantId}", tenantId)
          .replace("{id}", data.id)}`
      ).then((res) => {
        getSlotCounts();
        return res;
      });
      return resp;
    } catch (err) {
      return err;
    }
  };

  /*eslint-disable */
  useEffect(() => {
    getSlotCounts();
    getVehicleParkingOptions();
  }, []);
  /*eslint-enable */

  return {
    open,
    columns,
    loading,
    formValues,
    isDisabled,
    errorMessage,
    vehicleTypeOptions,
    parkingOptions,
    rows,
    setOpen,
    handleClose,
    handleOpenForm,
    findDuplicateSlotCount: handleSubmit,
    handleInputChange,
    handleSearchChange,
  };
}
